<template>
  <div class="row">
    <div class=" column header_style col-md-12">
      <div class="d-flex flex-column flex-lg-row">
        <div class="filter-sidebar-wrapper">
          <button
            class="btn btn-light d-lg-none mb-2 w-100 text-left"
            @click="showFilterPanel = !showFilterPanel"
          >
            <i :class="showFilterPanel ? 'uil-angle-up' : 'uil-angle-down'" class="mr-1"></i>
            Filters
          </button>
          <div class="dropdown-job-filter job-card-item p-4" :class="{ 'd-none d-lg-block': !showFilterPanel }">
            <div class="pb-2 d-none d-lg-block">
              <span>Filters:</span>
            </div>
            <div class="filter-controls">
              <div >
                <div class="py-1">
                  <multiselect
                    ref="Company"
                    autocomplete
                    v-model="filterItems.company"
                    :options="companyOptions"
                    :searchable="true"
                    placeholder="Company"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.company, 'Company')"
                  ></multiselect>
                </div>
                <div class="py-1">
                  <multiselect
                    v-model="filterItems.minimumSalary"
                    :options="salaryRangeOptions"
                    :searchable="true"
                    placeholder="Minimum Salary"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.minimumSalary, 'Minimum Salary')"
                    @tag="addTagMin"
                    :taggable="true"
                    :multiple="false"
                  ></multiselect>
                </div>
                <div class="py-1">
                  <multiselect
                    v-model="filterItems.maximumSalary"
                    :options="salaryRangeOptions"
                    :searchable="true"
                    placeholder="Maximum Salary"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.maximumSalary, 'Maximum Salary')"
                    @tag="addTagMax"
                    :taggable="true"
                    :multiple="false"
                  ></multiselect>
                </div>
                <div class="py-1">
                  <multiselect
                    v-model="filterItems.commission"
                    :options="commissionOptions"
                    :searchable="true"
                    placeholder="Commission"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.commission, 'Commission')"
                    @tag="addTagCommission"
                    :taggable="true"
                    :multiple="false"
                  ></multiselect>
                </div>
      
                <div class="py-1">
                  <multiselect
                    v-model="filterItems.status"
                    :options="statusOptions"
                    :searchable="true"
                    placeholder="Status"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.status, 'Status')"
                  ></multiselect>
                </div>
                <!-- <div class="col-md-2 custom-job-sort" >
                  <b-nav-item-dropdown
                    variant="black"
                    class="dropdown d-none d-lg-block nav-link"
                    style="padding: 0;"
                    >
                    <template v-slot:button-content>
                      <router-link
                        class="btn2 btn2-primary btn2-md px-5"
                        tag="button"
                        to=""
                      >
                        SORT
                      </router-link>
                    </template>
                    <b-dropdown-item 
                      href="javascript:void(0);"
                      class="notify-item"
                      @click.native="onSortBy('min_salary')"
                    >
                      Minimum Salary
                      <i v-if="sortBy == 'min_salary' && isDesc" class="uil uil-angle-up ml-1" />
                      <i v-if="sortBy == 'min_salary' && !isDesc" class="uil uil-angle-down ml-1" />
                    </b-dropdown-item>
                    <b-dropdown-item 
                      href="javascript:void(0);"
                      class="notify-item"
                      @click.native="onSortBy('max_salary')"
                    >
                      Maximum Salary
                      <i v-if="sortBy == 'max_salary' && isDesc" class="uil uil-angle-up ml-1" />
                      <i v-if="sortBy == 'max_salary' && !isDesc" class="uil uil-angle-down ml-1" />
                    </b-dropdown-item>
                    <b-dropdown-item 
                      href="javascript:void(0);"
                      class="notify-item"
                      @click.native="onSortBy('updatedAt')"
                    >
                      Updated At
                      <i v-if="sortBy == 'updatedAt' && isDesc" class="uil uil-angle-up ml-1" />
                      <i v-if="sortBy == 'updatedAt' && !isDesc" class="uil uil-angle-down ml-1" />
                    </b-dropdown-item>
                  </b-nav-item-dropdown>
                </div> -->

                <div class="py-1">
                  <multiselect
                    ref="Brand"
                    autocomplete
                    v-model="filterItems.brand"
                    :options="brandOptions"
                    :searchable="true"
                    placeholder="Brand"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.brand, 'Brand')"
                  ></multiselect>
                </div>

                <div v>
                  <multiselect
                    ref="Function"
                    autocomplete
                    v-model="filterItems.function"
                    :options="functionOptions"
                    :searchable="true"
                    placeholder="Function"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
      
                    track-by="name"
                    label="name"
                    @input="onInputFilter(filterItems.function, 'Function')"
                  ></multiselect>
                </div>
      
                <div class="py-1">
                  <flat-pickr
                    v-model="filterItems.dateRange"
                    class="form-control"
                    placeholder="Date Range"
                    @on-change="onInputFilter(filterItems.dateRange, 'Date Range')"
                    :config="{ mode: 'range' }"
                  ></flat-pickr>
                </div>
      
                <!-- <div class="custom-col-padding mx-3"  style="width: 18%;">
                  <flat-pickr
                    v-model="filterItems.startDate"
                    class="form-control"
                    placeholder="Start Date"
                    @on-change="onInputFilter(filterItems.startDate, 'Start Date')"
                  ></flat-pickr>
                </div>
      
                <div class="custom-col-padding"  style="width: 18%;">
                  <flat-pickr
                    v-model="filterItems.endDate"
                    class="form-control"
                    placeholder="End Date"
                    @on-change="onInputFilter(filterItems.endDate, 'End Date')"
                  ></flat-pickr>
                </div> -->
              </div>
              
            </div>
            <div class="col-1"></div>
          </div>
        </div>
        <div class="flex-grow-1 job-content-area">
          <div class="d-flex flex-wrap justify-content-end pl-lg-4 mb-3 search-toolbar">
            <label class="flex-grow-1" style="padding-bottom: 0 !important; margin-bottom: 0;">
              <b-input-group class="advance-search-field job-advance-search">
                <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-md SearchInput"
                  @keydown.enter.native="onUpdateFilter"
                ></b-form-input>
                <b-input-group-prepend class="btn2 btn2-tertiary">
                  <span 
                    class="input-group-text bg-white" 
                    :class="role_modules.some(item => item.value == 'job.advance_search') ? '' : 'right-search-border'" 
                    @click="onUpdateFilter"
                  >
                    <i class="uil-search"></i>
                  </span>
                </b-input-group-prepend>
                <b-input-group-prepend class="btn2 btn2-tertiary" v-if="role_modules.some(item => item.value == 'job.advance_search') && (1==0)">
                  <span class="input-group-text bg-white right-search-border" @click="showAdvanceSeach = !showAdvanceSeach"><i class="uil-sliders-v" style="transform: rotate(270deg);"></i></span>
                </b-input-group-prepend>
              </b-input-group>
              <b-input-group 
                v-show="showAdvanceSeach" 
                class="custom-advance-search" 
              >
                <hrflow-fields-search
                  hasButton
                  ref="advanceSearch"
                  class="w-100"
                  @onSearchField="onSearch"
                />
              </b-input-group>
            </label>
            
            <button 
              type="button"
              class="btn btn-success ml-2 mr-1" 
              @click="$emit('onExportData')" v-if="role_modules.some(item => item.value == 'job.export')"
            >
              <i class="uil-download-alt"></i>
            </button>
            
            <slot name="custom-filter2"></slot>
          </div>
          <div v-if="filterData.length" class="d-flex flex-wrap align-items-center pt-3 pl-lg-4">
            <div class="col-12 col-md-2">
              <span class="header">FILTERS APPLIED:</span>
            </div>
            <div class="flex-grow-1 d-flex flex-wrap">
              <div 
                class="p-1"
                v-for="(data, idx) in filterData"
                :key="idx"
              >
                <div class="chip" style="border: 1px solid #0300133D !important;" >
                  <span style="font-size: 12px;">{{ data.field }}: </span>
                  <span style="font-size: 12px;">{{ data.value }}</span>
                  <span class="closebtn" @click="removeFilter(idx, data.field)">&times;</span>
                </div>
              </div>
              <div class="p-1">
                <b-button class="custom-button" size="sm" @click="removeFilter" style=" border-radius: 25px;height:30px">
                  Clear Filters
                </b-button>
              </div>
            </div>
          </div>
          <slot name="joblist"></slot>
        </div>
      </div>
     

      
    </div>
    <div class="col-md-1"></div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import hrflowFieldsSearch from '../../pages/job/components/dialogs/hrflowFieldsSearch.vue'

export default {
  components: {
    Multiselect,
    hrflowFieldsSearch
  },
  props:{
  },
  computed: {
 
  },
  data() {
    return {
      commissionOptions: [],
      statusOptions: [
        { name: 'All' },
        { name: 'Draft' },
        { name: 'Posted' },
        { name: 'Unposted' },
        { name: 'Title Changed' },
        { name: 'Description Changed' },
      ],
      companyOptions: [],
      functionOptions: [],
      brandOptions: [],
      salaryRangeOptions: [],
      filterItems: {
        company: '',
        minimumSalary: '',
        maximumSalary: '',
        commission: '',
        status: '',
        startDate: '',
        endDate: '',
        dateRange: '',
        function_id: '',
        brand_id: ''
      },
      filterData: [],
      filter: '',
      isSort: false,
      sortBy: 'updatedAt',
      isDesc: true,
      showAdvanceSeach: false,
      showFilterPanel: false
    }
  },
  methods:{
    onInputFilter(val, field) {
      let data = this.filterData
      let newData = []
      let isFilter = false
      let value = typeof val == 'object' ?  val.name : val
      if(val && field){
        for(let key in data){
          let item = data[key].field
          if(item == field){
            isFilter = true
            data[key].value = value
          }
          newData.push(data[key])
        }
  
        if(isFilter){
          this.filterData = newData
        }else{
          this.filterData.push({
            field: field,
            value: value
          })
        }
      }

      this.onUpdateFilter()
    },
    removeFilter(idx, field) {
      if(field){
        let formattedField = this.camelize(field)
        this.filterItems[`${formattedField}`] = ''
        this.filterData.splice(idx, 1)
      }else{
        this.filterData = []
        this.filterItems = {
          company: '',
          function: '',
          startDate: '',
          endDate: '',
          dateRange: '',
          minimumSalary: '',
          maximumSalary: '',
          commission: '',
          status: '',
          function_id: '',
          brand_id: ''
        }
        // this.isSort = false
      } 

      this.onUpdateFilter()
    },
    onUpdateFilter(){
      this.onAddToCookie()
      let items = this.filterItems && typeof this.filterItems == 'object' ? this.filterItems : ''

      let { dateRange } = items
      const dates = dateRange ? dateRange.split(" to ") : [];

      let filter = {
        company: items && typeof items.company == 'object' && items.company._id ? items.company._id : '',
        function_id: items && typeof items.function == 'object' && items.function._id ? items.function._id : '',
        brand_id: items && typeof items.brand == 'object' && items.brand._id ? items.brand._id : '',
        minimumSalary: items && typeof items.minimumSalary == 'object' && items.minimumSalary.value ? items.minimumSalary.value : '',
        maximumSalary: items && typeof items.maximumSalary == 'object' && items.maximumSalary.value ? items.maximumSalary.value : '',
        commission: items && typeof items.commission == 'object' && items.commission.value ? items.commission.value : '',
        startDate: items && items.startDate ? items.startDate : dates.length ? dates[0] : '',
        endDate: items && items.endDate ? items.endDate : dates.length > 1 ? dates[1] : '',
        status: items && typeof items.status == 'object' && items.status.name ? items.status.name : '',
        filter: this.filter || '',
        sortBy: this.isSort ? this.sortBy : '',
        isDesc: this.isDesc,
        count: this.filterData.length
      }
      
      this.$emit('onFilter', filter || '')
    },
    fetchFilterOptions(){
      this.$store.dispatch('company/all')
      .then(res => {
        this.companyOptions = res.data
      })

      for(let index = 0; index <= 10; index++) {
        let val = index ? index.toString() + '0' : index.toString()
        this.commissionOptions.push({ name: val + '%', value: val })
      }

      for(let index = 0; index <= 15; index++) {
        let val = index ? index.toString() + '000000' : index.toString()
        this.salaryRangeOptions.push({ name: '¥' + this.numberWithCommas(val), value: val })
      }

      this.$store.dispatch('function/all')
      .then(res => {
        this.functionOptions.push({_id: 'no_function', name: 'No Function'})
        this.functionOptions.push(...res.data)
      })

      this.$store.dispatch('brand/all')
      .then(res => {
        this.brandOptions.push({_id: 'no_brand', name: 'No brand'})
        this.brandOptions.push(...res.data)
      })
      // this.commissionOptions = Array(100).fill(1).map((n, i) => n + i)
    },
    addTagMin(val) {
      let newTag = val.toString()
      let isTag = this.salaryRangeOptions.filter(el => { return el.value == newTag })

      let option = { name: '¥' + this.numberWithCommas(newTag), value: newTag }
      if(!isTag){
        this.salaryRangeOptions.push(option)
      }
      this.filterItems.minimumSalary = option
      this.onInputFilter(option, 'Minimum Salary')
    },
    addTagMax(val) {
      let newTag = val.toString()
      let isTag = this.salaryRangeOptions.filter(el => { return el.value == newTag })

      let option = { name: '¥' + this.numberWithCommas(newTag), value: newTag }
      if(!isTag){
        this.salaryRangeOptions.push(option)
      }
      this.filterItems.maximumSalary = option
      this.onInputFilter(option, 'Maximum Salary')
    },
    addTagCommission(val) {
      let newTag = val.toString()
      let isTag = this.commissionOptions.filter(el => { return el.value == newTag })

      let option = { name: newTag + '%', value: newTag }
      if(!isTag){
        this.commissionOptions.push(option)
      }
      this.filterItems.commission = option
      this.onInputFilter(option, 'Commission')
    },
    camelize(str) {
      return str
        .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
    },
    numberWithCommas(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onSortBy(sortBy){
      this.isSort = true
      this.isDesc = !this.isDesc
      this.sortBy = sortBy
      this.onUpdateFilter()
    },
    onSearch(val) {
      this.$emit('onSearchField', {model: val, is_reset: !this.showAdvanceSeach})
      this.showAdvanceSeach = false
    },
    onAddToCookie() {
      this.$cookie.set('filterData', JSON.stringify(this.filterData))
      this.$cookie.set('filterItems', JSON.stringify(this.filterItems))
    },
    getCookie()  {
      let filterData = this.$cookie.get('filterData')
      filterData = JSON.parse(filterData)
      let filterItems = this.$cookie.get('filterItems')
      filterItems = JSON.parse(filterItems)

      if (filterData?.length) {
        this.filterData = filterData
        this.filterItems = filterItems
      }
    }
  },
  mounted(){
    this.fetchFilterOptions()
    this.getCookie()
  },
}
</script>

<style scoped>
.filter-controls {
  width: 255px;
}
.job-content-area {
  min-width: 0;
}
@media (max-width: 991px) {
  .filter-sidebar-wrapper {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .filter-controls {
    width: 100%;
  }
  .dropdown-job-filter {
    padding: 0.75rem !important;
  }
  .job-content-area {
    width: 100% !important;
  }
  .search-toolbar {
    padding-left: 0 !important;
    gap: 0.5rem;
  }
}
@media (max-width: 575px) {
  .filter-controls {
    width: 100%;
  }
}
</style>
